module.exports = "https://static.energy5.com/_next/static/images/appStore-f7cb7f639595066690d5b8cab0a2a819.png";